module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/th_hokkaido-af672358783e13f1543d566e48623acf.jpg";